import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { IntegrationsService } from 'src/app/integrations/integrations.service'

@Injectable({
  providedIn: 'root'
})
export class ZohoCallbackGuard implements CanActivate {
  constructor(private router: Router, private integrationsService: IntegrationsService) {}

  canActivate(): boolean {
    const params = new URLSearchParams(window.location.search)

    const success = params.get('success')
    const provider = params.get('provider')

    // If NO params → do nothing → allow page to load normally
    if (!success || !provider) {
      return true
    }

    // If Zoho success → update integration
    if (success === '1' && provider === 'zoho') {
      this.integrationsService.setIntegrationConnected('zoho', true).subscribe(() => {
        this.router.navigate(['/integrations'])
      })
      return false
    }

    // If callback has success=0 → just show normal homepage
    return true
  }
}
